module.exports = __webpack_public_path__ + "static/slide-1-65bd3e7b8b379c166b94d425e5163b2e.png";